import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetBetsPositionModel,
  IGetBetsPositionRequest,
  IMappers,
  IGetBetsPositionResponse,
  IGetBetsPositionResponseError,
  TGetBetsPositionResponse,
} from './types';

const defaultConfig: TGetBetsPositionModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'auction',
  pathApi: '/v1/get-bets-position/',
  hostType: 'api',
} as TGetBetsPositionModel;

function createGetBetsPositionModel(parameters: IGetBetsPositionRequest): TGetBetsPositionModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetBetsPositionOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetBetsPositionRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetBetsPosition<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetBetsPositionOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetBetsPositionResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetBetsPositionModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetBetsPositionResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetBetsPositionResponseError);
    }
  }

  return { response, statusCode } as TGetBetsPositionResponse;
}

export { defaultConfig, createGetBetsPositionModel, fetchGetBetsPosition };
